import { Link } from '@tanstack/react-router';
import { Link2 } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type DuplicateLocationDisplay = {
  guid: string;
  display_name: string;
  folder_name: string;
};

interface DuplicateLocationsIndicatorProps {
  slug: string;
  locations: DuplicateLocationDisplay[];
  onDocumentClick: (documentGuid: string) => void;
  className?: string;
}

export const DuplicateLocationsIndicator = ({
  slug,
  locations,
  onDocumentClick,
  className = "absolute left-[calc(50%+14px)] h-3 w-3 text-gray-400 hover:text-gray-600 shrink-0",
}: DuplicateLocationsIndicatorProps) => {
  if (locations.length === 0) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link2
            className={className}
            onClick={(e) => e.stopPropagation()}
            onDoubleClick={(e) => e.stopPropagation()}
          />
        </TooltipTrigger>
        <TooltipContent className="bg-gray-100 text-gray-800 rounded-lg shadow-lg p-3 max-w-sm">
          <div className="text-sm font-semibold mb-2">Also appears as:</div>
          {locations.map((loc, idx) => (
            <div key={`${loc.guid}-${idx}`} className="text-xs text-gray-600 mb-1">
              &bull;{' '}
              <Link
                to="/matter/$slug/f/$fileId"
                params={{ slug, fileId: loc.guid }}
                onClick={(e) => {
                  if (e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    onDocumentClick(loc.guid);
                  }
                }}
                className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer max-w-[200px] truncate inline-block align-bottom"
                title={loc.display_name}
              >
                {loc.display_name}
              </Link>
              {' '}in {loc.folder_name}
            </div>
          ))}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
